exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DateVcDemo h4[data-v-5d26a4dc]{color:#066}.DateVcDemo .demoItem[data-v-5d26a4dc]{padding:10px 0;font-size:18px;border-bottom:1px dotted #999}.DateVcDemo p[data-v-5d26a4dc]{margin:10px}", ""]);

// exports
